var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8749 10.0625V19.8125C17.8749 20.2435 17.7037 20.6568 17.3989 20.9615C17.0942 21.2663 16.6809 21.4375 16.2499 21.4375H4.87488C4.34138 21.4375 3.81311 21.3324 3.32023 21.1283C2.82734 20.9241 2.37949 20.6249 2.00226 20.2476C1.24039 19.4858 0.812378 18.4524 0.812378 17.375V7.625C0.812378 7.19402 0.983583 6.7807 1.28833 6.47595C1.59308 6.1712 2.0064 6 2.43738 6H13.8124C14.8898 6 15.9231 6.42801 16.685 7.18988C17.4469 7.95174 17.8749 8.98506 17.8749 10.0625ZM24.7811 8.14297C24.6587 8.06853 24.5182 8.02917 24.3749 8.02917C24.2316 8.02917 24.0911 8.06853 23.9686 8.14297L19.9061 10.4586C19.7815 10.5305 19.6783 10.6342 19.6069 10.7591C19.5355 10.8841 19.4986 11.0257 19.4999 11.1695V16.268C19.4986 16.4118 19.5355 16.5534 19.6069 16.6784C19.6783 16.8033 19.7815 16.907 19.9061 16.9789L23.9686 19.2945C24.0924 19.3656 24.2322 19.404 24.3749 19.4062C24.5178 19.4054 24.6579 19.3668 24.7811 19.2945C24.9056 19.2251 25.0091 19.1233 25.0806 19C25.1521 18.8767 25.189 18.7363 25.1874 18.5937V8.84375C25.189 8.70119 25.1521 8.56085 25.0806 8.43751C25.0091 8.31417 24.9056 8.21241 24.7811 8.14297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.fd09d271192e729741fbd09a8cd2fa90.svg";
export { ForwardRef as ReactComponent };